var map = {
	"./or-en.svg": 1267,
	"./or-zh-hk.svg": 1268
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1266;


//////////////////
// WEBPACK FOOTER
// ./src/resource/img ^\.\/or\-.*\.svg$
// module id = 1266
// module chunks = 0